<!-- template for the modal component -->
<template>
  <transition name="modal">
    <div class="modal-mask" @click="closeModal" v-if="open">
      <div class="modal-wrapper">
        <div class="modal-container" @click.stop>

          <div class="modal-header"><h3>{{title}}</h3></div>

          <div class="modal-body">
          	{{body}}
          	<textarea v-show="code" @focus="$event.target.select()">{{code}}</textarea> 
          </div>

          <div class="modal-footer">
            <button class="btn modal-default-button" @click="closeModal">OK</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
	export default {
		name: 'modal',
		props: ['open','title','body','code'],
		mounted: function () {
			document.addEventListener("keydown", (e) => {
				if(this.open && e.keyCode == 27){
					this.$emit('closeModal');
				}
			});
		},
		methods: {
			closeModal(){
				this.$emit('closeModal');
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/modal.vue